// React
import React, { useState, useEffect, useCallback } from 'react';
import { BeatLoader } from 'react-spinners';
import { useHistory, useLocation } from 'react-router-dom';
import FilePreview from 'react-preview-file';

// Kendo
import kendo from '@progress/kendo-ui';
import { Form, Field, FormElement } from '@progress/kendo-react-form';
import { Button } from '@progress/kendo-react-buttons';
import { Dialog } from '@progress/kendo-react-dialogs';
import { Input, TextArea } from '@progress/kendo-react-inputs';
import { Error } from '@progress/kendo-react-labels';
import { Checkbox } from '@progress/kendo-react-inputs';
import { IntlProvider, LocalizationProvider } from '@progress/kendo-react-intl';

// Css
import './elderMngt.css';
import './elderInfo.css';
import { DropDownList } from '@progress/kendo-react-dropdowns';

// DatePicker
import DatePickerKo from '../../com/dateInputs/datePickerKo';
import DateTimePickerKo from '../../com/dateInputs/dateTimePickerKo';

//component
import ElderAddress from "./elderAddress";
import { parseDate } from '../../../com/dateUtil';
import { checkDuplicatedCid, checkDuplicatedId } from '../../../service/mngt/managerService';
import { getUser, isAdmin, isLogin } from '../../../service/authService';
import { getRgns, getDongs } from './../../../service/areaService';
import { getUsers } from '../../../service/monitor/allStatusService';

const ElderInfo = ({ conn, rgnList, dongList, isNew, elderInfo, setElderInfo, submitData, dataItem, managerList }) => {
  
  const userInfo = getUser();
  const history = useHistory();
  const [loading, setLoading] = useState(false);

  const isManager = userInfo.userTypeCode === 2002;
  const isRgnManager = userInfo.userTypeCode === 2003;
  const isDeveloper = userInfo.userTypeCode === 2005;

  // 데이터 상태 관리
  const [data, setData] = useState({
    notePickYn: dataItem ? (dataItem.mngtTarget === 'Y' ? true : false) : false,
    isFirstBiz: dataItem ? (dataItem.isFirstBiz === 'Y' ? true : false) : false,
    rgn: !isDeveloper ? rgnList.find(item => item.rgnCode === userInfo.rgnCode) : { rgnCode: '', rgnTermSimple: '주소검색' },
    dong: isManager ? dongList.find(item => item.dongCode === userInfo.dongCode) : { dongCode: '', dongTermSimple: '주소검색' },
    manager: isManager ? managerList.find(item => item.userId === userInfo.userId) : { userId: '', userTerm: '담당자 선택' },
    bizType: { bizType: '', bizTypeTerm: '장비구분 선택' },


    // 드롭다운 시군구 표출 값
    rgnCode: userInfo.rgnCode,
    rgnTermSimple: null,
    rgns : { rgnTermSimple: "시/군/구", rgnCode: "" },
    // 드롭다운 읍면동 표출 값
    dongCode: userInfo.dongCode,
    dongTermSimple: null,
    dongs : { dongTermSimple: "읍/면/동", dongCode: "" },
    // 드롭다운 유저 표출 값
    userId: '',
    userTerm: '',
    users: { userTerm: "대상자 선택", userId: "" },
    fileId: '',
  });
  const [userId, setUserId] = useState({ value: '', check: false });
  const [cid, setCid] = useState({ value: '', check: false });

  // 취소시 원복
  const [copyDataItem, setCopyDataItem] = useState({});

  // const phoneRegex = new RegExp(/^\d{3}-\d{3,4}-\d{4}$/);
  const phoneRegex = new RegExp(/^\d{3}\d{3,4}\d{4}$/);
  const phoneValidator = useCallback(value => (value ? (phoneRegex.test(value) ? '' : ' ') : ''));

  const defualtValRgn = { rgnTermSimple: "시/군/구", rgnCode: "" };
  const defualtValDong = { dongTermSimple: "읍/면/동", dongCode: "" };
  const defaultValUser = { userTerm: "대상자 선택", userId: "" };

  const [dataSource, setDataSource] = useState({
    rgnList: [], 
    dongList: [],
    userList: [],
  });

  const [filesState, setFilesState] = useState({
    files: [],
    fileInfo: [],
    fileId: '',
  });
  const [imgFile, setImgFile] = useState();
  //사진 등록 시 미리보기
  const [previewFile, setPreviewFile] = useState();
  

  // 닫기 이벤트
  const closeEvt = () => {
    // dataItem = copyDataItem;
    setElderInfo(elderInfo => {
      const item = { ...elderInfo };
      item.visible = !elderInfo.visible;
      item.dataItem = {};
      item.isNew = false;
      return item;
    });
  };

  // 초기 데이터 가져오기
  const getDataList = () => {
    setLoading(true);
    // 시군구
    getRgns(conn)
    .then(response => {
      setData(data => {
        const item = { ...data };
        item.rgns = response.find(item => item.rgnCode === userInfo.rgnCode);
        return item;
      })
      setDataSource(dataSource => {
        const item = { ...dataSource };
        item.rgnList = response
        return item;
      })
      setLoading(false);
    })
    .catch(error => {
      console.log("getRgns error = ", error);
    });
    // 읍면동
    getDongs(conn, userInfo.rgnCode)
    .then(response => {
      setData(data => {
        const item = { ...data };
        item.dongs = response.find(item => item.dongCode === userInfo.dongCode);
        return item;
      })
      setDataSource(dataSource => {
        const item = { ...dataSource };
        item.dongList = response;
        return item;
      })
      setLoading(false);
    })
    .catch(error => {
      console.log("getDongs error = ", error);
    });
    // 대상자
    getUsers(conn, data)
    .then(response => {
      setDataSource(dataSource => {
        const item = { ...dataSource };
        // item.userList = response;
        item.userList = response.filter(item => item.meainStatCode !== "20005");
        return item;
      })
    })
    .catch(error => {
      console.log("getUserList error = ", error);
    })
  }

  // ****  Validation
  // phone
  const PhoneInput = useCallback(fieldRenderProps => {
    const { validationMessage, visited, ...others } = fieldRenderProps;
    return (
      <div>
        <Input {...others} />
        {visited && validationMessage && <Error>{validationMessage}</Error>}
      </div>
    );
  });

  // 생년월일 컴포넌트
  const birthDayComponent = formRenderProps => {
    if (!formRenderProps.value) {
      formRenderProps.onChange({ value: kendo.toString(new Date('1940-01-01'), 'yyyy-MM-dd') });
    }
    return (
      <DatePickerKo
        format="yyyy.MM.dd"
        value={new Date(formRenderProps.value)}
        setDtm={v => {
          formRenderProps.onChange({ value: kendo.toString(v, 'yyyy-MM-dd') });
        }}
      />
    );
  };

  const genderList = ['M', 'W'];
  // 성별 컴포넌트
  const genderComponent = formRenderProps => {
    const genderChange = (e) => {
      formRenderProps.onChange({ value: e.target.value });
    }
    return (
      <DropDownList
        data={genderList}
        required={true}
        value={formRenderProps.value}
        validationMessage={'성별을 선택 해주세요.'}
        onChange={genderChange}></DropDownList>
    );
  }

  const bizTypeList = [
    {bizType: "5001", bizTypeTerm: "1차 검은색 장비"},
    {bizType: "5002", bizTypeTerm: "2차 흰색 장비"},
    {bizType: "5003", bizTypeTerm: "3차 안심박스"},
  ]
  // 1차 사업 구분 컴포넌트
  const bizTypeComponent = formRenderProps => {
    const bizTypeChange = (e) => {
      formRenderProps.onChange({ value: e.value.bizType });
      setData(data => {
        const item = { ...data };
        item.bizType = { bizType: e.value.bizType, bizTypeTerm: e.value.bizTypeTerm };
        return item;
      });
    }
    return (
      <DropDownList
        data={bizTypeList}
        required={true}
        textField="bizTypeTerm"
        dataItemKey="bizType"
        value={data.bizType}
        defaultItem={{ bizType: '', bizTypeTerm: '장비구분 선택' }}
        validationMessage={'장비구분을 선택 해주세요.'}
        onChange={bizTypeChange}></DropDownList>
    );
    // //5001 1차사업 , 이외는 2차사업
    // if (!formRenderProps) formRenderProps.onChange({ value: '5002' });

    // const handleChange = e => {
    //   formRenderProps.onChange({ value: formRenderProps.value === '5001' ? '5002' : '5001' });
    // };
    // return <Checkbox checked={formRenderProps.value === '5001'} onChange={handleChange} label={'1차 사업'} />;
  };

  // 담당자 드롭다운 컴포넌트
  const managerComponent = formRenderProps => {
    if (!formRenderProps.value && isManager) {
      formRenderProps.onChange({ value: userInfo.userId });
    }
    const handleChange = e => {
      formRenderProps.onChange({ value: e.value.userId });
      setData(data => {
        const item = { ...data };
        item.manager = { userId: e.value.userId, userTerm: e.value.userTerm };
        return item;
      });
    };

    return (
      <DropDownList
        data={managerList}
        disabled={isManager}
        textField="userTerm"
        dataItemKey="userId"
        value={data.manager}
        defaultItem={{ userId: '', userTerm: '담당자 선택' }}
        required={true}
        validationMessage={'담당자를 선택 해주세요.'}
        onChange={handleChange}></DropDownList>
    );
  };

  // *** 시군구 드롭다운 컴포넌트
  const rgnComponent = formRenderProps => {
    if ((!formRenderProps.value && isManager) || (!formRenderProps.value && isRgnManager)) {
      formRenderProps.onChange({ value: userInfo.rgnCode });
    }
    const handleChange = e => {
      formRenderProps.onChange({ value: e.value.rgnCode });
      setData(data => {
        const item = { ...data };
        item.rgn = { rgnCode: e.value.rgnCode, rgnTermSimple: e.value.rgnTermSimple };
        // 드롭다운 검색조건 변경
        item.rgnCode = e.target.value.rgnCode;
        item.rgns = e.target.value;
        // 하위 데이터 초기화
        item.dongs = { dongTermSimple: "읍/면/동", dongCode: "" };
        item.dongCode = "";
        return item;
      });
      // 읍면동 데이터 조회
      getDongs(conn, e.value.rgnCode)
      .then(result => {
        setDataSource(dataSource => {
          const item = { ...dataSource };
          item.dongList = result;
          return item;
        })
      })
      .catch(error => {
        console.log("getDongs error = ", error);
      });
      formRenderProps.onChange({ value: e.value.rgnCode });
    };
    return (
      <div>
        <DropDownList
          id="rgn"
          name="rgn"
          data={dataSource.rgnList}
          disabled={!isDeveloper ? true : false}
          value={data.rgn}
          textField="rgnTermSimple"
          dataItemKey="rgnCode"
          defaultItem={defualtValRgn}
          onChange={handleChange}
          popupSettings={{ width: '210px' }}
          required={true}
          validationMessage={'담당 시군구를 선택 해주세요.'}
          itemRender={itemRender}
        />
      </div>
    );
  }

  // *** 읍면동 드롭다운 컴포넌트
  const dongComponent = formRenderProps => {
    if (!formRenderProps.value && isManager) {
      formRenderProps.onChange({ value: userInfo.dongCode });
    }
    const handleChange = e => {
      setData(data => {
        const item = { ...data };
        item.dong = { dongCode: e.value.dongCode, dongTermSimple: e.value.dongTermSimple };
        // 드롭다운 검색조건 변경
        item.dongCode = e.target.value.dongCode;
        item.dongs = e.target.value;
        return item;
      });
      formRenderProps.onChange({ value: e.value.dongCode });
    };

    return (
      <div>
        <DropDownList
          id="dong"
          name="dong"
          data={dataSource.dongList}
          disabled={!isAdmin() ? true : !data.rgnCode ? true : false}
          value={data.dong}
          textField="dongTermSimple"
          dataItemKey="dongCode"
          defaultItem={defualtValDong}
          onChange={handleChange}
          popupSettings={{ width: '210px' }}
          required={true}
          validationMessage={'담당 읍면동을 선택 해주세요.'}
          itemRender={itemRender}
        />
      </div>
    );
  };

  // 설치 일시 캘린더 컴포넌트
  const installDtmComponent = formRenderProps => {
    if (!formRenderProps.value) {
      formRenderProps.onChange({ value: parseDate('yyyy-mm-dd hh:mm:ss', new Date()) });
    }
    return (
      <DateTimePickerKo
        value={new Date(formRenderProps.value)}
        setDtm={v => {
          formRenderProps.onChange({ value: parseDate('yyyy-mm-dd hh:mm:ss', v) });
        }}
      />
    );
  };

  // 위험대상자 체크박스 컴포넌트
  const dangerYnComponent = formRenderProps => {
    if (!formRenderProps.value) formRenderProps.onChange({ value: 'N' });
    const handleChange = e => {
      formRenderProps.onChange({ value: formRenderProps.value === 'Y' ? 'N' : 'Y' });
    };
    return <Checkbox checked={formRenderProps.value === 'Y'} onChange={handleChange} label={'체크 시 위험 대상자로 전환'} />;
  };

  // 장기부재 체크박스 컴포넌트
  const absenceYnComponent = formRenderProps => {
    if (!formRenderProps.value) formRenderProps.onChange({ value: 'N' });
    const handleChange = e => {
      formRenderProps.onChange({ value: formRenderProps.value === 'Y' ? 'N' : 'Y' });
    };
    return <Checkbox checked={formRenderProps.value === 'Y'} onChange={handleChange} label={'체크 시 위험 상태로 전환되지 않음'} />;
  };

  // 위치추적 체크박스 컴포넌트
  const locationYnComponent = formRenderProps => {
    if (!formRenderProps.value) formRenderProps.onChange({ value: 'N' });
    const handleChange = e => {
      formRenderProps.onChange({ value: formRenderProps.value === 'Y' ? 'N' : 'Y' });
    };
    return <Checkbox checked={formRenderProps.value === 'Y'} onChange={handleChange} label={'체크 시 위치추적 대상자로 전환'} />;
  };

  // 설치예정 체크박스 컴포넌트
  const installPlanComponent = formRenderProps => {
    if (!formRenderProps.value) formRenderProps.onChange({ value: '20003' });
    const handleChange = e => {
      formRenderProps.onChange({ value: formRenderProps.value === '20005' ? '20003' : '20005' });
    };
    return <Checkbox checked={formRenderProps.value === '20005'} onChange={handleChange} label={'체크 시 설치예정 대상자로 전환'} />;
  };

  const { kakao } = window;
  const [address, setAddress] = useState({ value: ''});
  const [lat, setLat] = useState({ value: '' });
  const [lng, setLng] = useState({ value: '' });
  const [latLngBoolean, setLatLngBoolean] = useState(false);

  const handleClick = (e) => {
    e.preventDefault();
    const geocoder = new kakao.maps.services.Geocoder();
    geocoder.addressSearch(address.value, (result, status) => {
      if(result.length === 0) {
        kendo.alert("도로명 주소가 올바르지 않습니다.");
      }
      if (status === kakao.maps.services.Status.OK) {
        // setAllowSubmit(true);
        const resultLat = result[0].y;
        const resultLng = result[0].x;
        
        setLat({ value: resultLat });
        setLng({ value: resultLng });
        setLatLngBoolean(true);
      }
    });
  }


  const selectUnitAddress = e => {
    const originalAddress = e.address;

    setAddress(address => ({...address, value: originalAddress}));
    setElderInfo(elderInfo => {
      const item = { ...elderInfo };
      item.addressInfo = false;
      return item;
    });
    
    const geocoder = new kakao.maps.services.Geocoder();
    geocoder.addressSearch(originalAddress, (result, status) => {
      if(result.length === 0) {
        kendo.alert("도로명 주소가 올바르지 않습니다.");
      }
      if (status === kakao.maps.services.Status.OK) {
        // setAllowSubmit(true);
        const resultLat = result[0].y;
        const resultLng = result[0].x;
        
        setLat({ value: resultLat });
        setLng({ value: resultLng });
        setLatLngBoolean(true);
      }
    });
  };

  const searchAddress = () => {
    setElderInfo(elderInfo => {
      const item = { ...elderInfo };
      item.addressInfo = true;
      return item;
    });
}

  // 주소 컴포넌트
  const addressInput = formRenderProps => {
    
    const handleChange = e => {
      formRenderProps.onChange({ value: e.value});
      address.value = e.value;
      // setAddress(e.target.value)
    }

    // return <Input type="text" value={address.value} onChange={handleChange}/>
    return <Input className="addressInput" id="address" type="text" name = {"address"}  value={address.value} onClick={searchAddress} autoComplete='off' readOnly/>
  }

  
  // 위도 컴포넌트
  const latInput = formRenderProps => {
    if(latLngBoolean) {
      formRenderProps.onChange({ value: lat.value });
      setLatLngBoolean(false);
    }
    // formRenderProps.onChange({ value: lat.value });
    const handleChange = e => {
      formRenderProps.onChange({ value: e.value });
      lat.value = e.value;
    };

    return <Input id="latInput" type="hidden" value={lat.value} onChange={handleChange} />
  }

  // 경도 컴포넌트
  const lngInput = formRenderProps => {
    if(latLngBoolean) {
      formRenderProps.onChange({ value: lng.value });
      setLatLngBoolean(false);
    }
    const handleChange = e => {
      formRenderProps.onChange({ value: e.value });
      lng.value = e.value;
    };

    return <Input id="lngInput" type="hidden" value={lng.value} onChange={handleChange} />
  }
   
  // 드롭다운 컨버터 함수
  const converterData = () => {
    if (dataItem) {
      const rgnData = rgnList.filter(v => v.rgnCode === dataItem.rgnCode)[0];
      const dongData = dongList.filter(v => v.dongCode === dataItem.dongCode)[0];
      const managerData = managerList.filter(v => v.userId === dataItem.managerId)[0];
      const bizTypeData = bizTypeList.filter(v => v.bizType === dataItem.bizType)[0];
      if (dongData && managerData) {
        setData({ ...data, rgn: rgnData, dong: dongData, manager: managerData, bizType: bizTypeData });
      }
      if (dataItem.cid) setCid({ value: dataItem.cid, check: true });
      if (dataItem.userPhone) setUserPhone({ value: dataItem.userPhone.replace(/-/g, '') })
      if (dataItem.protectorPhone) setProtectorPhone({ value: dataItem.protectorPhone.replace(/-/g, '') })
      if (dataItem.lat) setLat({ value: dataItem.lat })
      if (dataItem.lng) setLng({ value: dataItem.lng })
    }
  };

  // 드롭다운 리스트 아이템 스타일 변경  (아이템 렌더링)
  const itemRender = (li, itemProps) => {
    const itemChildren = <div className="elderInfodropDownItem">{li.props.children}</div>;
    return React.cloneElement(li, li.props, itemChildren);
  };

  //대상자 ID 변경 컴포넌트
  const idInput = formRenderProps => {
    const handleChange = e => {
      formRenderProps.onChange({ value: e.value });
      userId.value = e.value;
      userId.check = false;
    };

    return (
      <Input
        value={userId.value}
        style={{ width: '70%', display: 'inline' }}
        onChange={handleChange}
        placeholder="아이디 입력"
        readOnly={isNew === false ? true : false}></Input>
    );
  };

  //CID 변경 컴포넌트
  const cidInput = formRenderProps => {
    const handleChange = e => {
      formRenderProps.onChange({ value: e.value });
      cid.value = e.value;
      cid.check = false;
    };

    return <Input value={cid.value} style={{ width: '70%', display: 'inline' }} onChange={handleChange} placeholder="기기 CID 입력"></Input>;
  };

  const [userPhone, setUserPhone] = useState({ value: '' });
  const [protectorPhone, setProtectorPhone] = useState({ value: '' });

  // 번호 변경 컴포넌트
  const userPhoneComponent = formRenderProps => {
    const handleChange = e => {
      formRenderProps.onChange({ value: e.value.replace(/-/g, '') });
      userPhone.value = e.value.replace(/-/g, '');
    };

    return <Input value={userPhone.value} onChange={handleChange} placeholder="01012345678" minLength={10} maxLength={11} required/>;
  };
  
  // 번호 변경 컴포넌트
  const protectorPhoneComponent = formRenderProps => {
    const handleChange = e => {
      formRenderProps.onChange({ value: e.value.replace(/-/g, '') });
      protectorPhone.value = e.value.replace(/-/g, '');
    };

    return <Input value={protectorPhone.value} onChange={handleChange} placeholder="01012345678" minLength={10} maxLength={11} required/>;
  };

  // ID 중복확인 버튼 클릭 이벤트
  const duplIdCheck = e => {
    e.preventDefault();
    checkDuplicatedId(conn, userId.value)
      .then(response => {
        if (response) {
          kendo.alert('중복된 ID입니다. 다른 ID를 입력해주시기 바랍니다.');
          setUserId({ ...userId, check: false });
        } else {
          if (userId.value) {
            kendo.alert('사용가능한 ID입니다.');
            setUserId({ ...userId, check: true });
          } else {
            kendo.alert('ID를 입력해주세요.');
            setUserId({ ...userId, check: false });
          }
        }
      })
      .catch(error => {});
  };

  // CID 중복확인 버튼 클릭 이벤트
  const duplCidCheck = e => {
    e.preventDefault();
    checkDuplicatedCid(conn, cid.value)
      .then(response => {
        if (response) {
          kendo.alert('중복된 CID입니다. CID를 확인 후 다시 입력해 주시기 바랍니다.');
          setCid({ ...cid, check: false });
        } else {
          if (cid.value) {
            kendo.alert('사용가능한 CID입니다.');
            setCid({ ...cid, check: true });
          }
        }
      })
      .catch(error => {
        kendo.alert('기기 CID를 입력해주세요.');
        setCid({ ...cid, check: false });
      });
  };

  useEffect(() => {
    // 초창기 데이터 아이템 들기
    // setCopyDataItem(dataItem);
    // 컨버트 작업
    converterData();
    getDataList();
  }, []);

  return (
    <Dialog title={isNew === false ? '대상자 수정' : '대상자 추가'} onClose={closeEvt}>
      <div className="installerModalForm">
        <div className="leftModalItem">
          <div>ID</div>
          {/* <div>PW</div> */}
          <div>대상자 성함</div>
          <div>기기 CID</div>
          <div>장비구분</div>
          {
            data.bizType.bizType === "5003" ? <div>IMEI</div> : null
          }
          <div>생년월일</div>
          <div>성별</div>
          <div>시군구</div>
          <div>읍면동</div>
          <div>상세주소</div>
          <div>연락처</div>
          <div>담당자</div>
          {/* <div>담당자 성함</div> */}
          {/* <div>담당자 연락처</div> */}
          <div>보호자</div>
          <div>보호자 연락처</div>
          <div>설치일시</div>
          <div>거주유형</div>
          {/* <div>보유지병</div> */}
          <div>위험대상자</div>
          <div>장기부재</div>
          <div>위치추적</div>
          <div>설치예정자</div>
          <div className='noteFieldDiv'>특이사항</div>
          <div>장비설치위치</div>
          {/* <div>위도</div>
          <div>경도</div> */}
        </div>
        <div className="rightModalItem">
          <Form
            onSubmit={submitData}
            initialValues={dataItem}
            render={formRenderProps => (
              <FormElement>
                <div>
                  {isNew ? (
                    <>
                      <Field name="userId" component={idInput} />
                      <Button style={{ width: '25%' }} onClick={duplIdCheck} disabled={userId.check}>
                        중복확인
                      </Button>
                    </>
                  ) : (
                    <Field name="userId" component={Input} placeholder="아이디 입력" readOnly={elderInfo.isNew === false ? true : false} required />
                  )}
                </div>
                {/* <div>
                  <Field name="userPassword" component={Input} placeholder="비밀번호 변경시에만 입력" />
                </div> */}
                <div>
                  <Field name="userTerm" component={Input} placeholder="성함 입력" required />
                </div>
                <div>
                  <Field name="cid" component={cidInput} />
                  <Button style={{ width: '25%' }} onClick={duplCidCheck} disabled={cid.check}>
                    중복확인
                  </Button>
                </div>
                <div>
                  <Field name="bizType" component={bizTypeComponent} />
                </div>
                {
                  data.bizType.bizType === "5003" ? 
                  <div>
                    <Field name="imei" component={Input} placeholder="IMEI 입력" required />
                  </div> : null
                }
                <div>
                  <Field name="birthday" component={birthDayComponent} />
                </div>
                <div>
                  <Field name="userGender" component={genderComponent} />
                </div>
                <div>
                  <Field name="rgnCode" component={rgnComponent} />
                </div>
                <div>
                  <Field name="dongCode" component={dongComponent} />
                </div>
                <div>
                  <Field name="address" component={Input} placeholder="상세주소 입력" required />
                </div>
                <div>
                  <Field name="userPhone" component={userPhoneComponent}/>
                </div>
                <div>
                  <Field name="managerId" component={managerComponent} />
                </div>
                {/* <div>
                  <Field name="managerTerm" component={Input} placeholder="담당자 입력" required />
                </div>
                <div>
                  <Field name="managerPhone" component={Input} placeholder="담당자 연락처 입력" required />
                </div> */}
                <div>
                  <Field name="protectorTerm" component={Input} placeholder="보호자 입력" />
                </div>
                <div>
                  <Field name="protectorPhone" component={protectorPhoneComponent}/>
                  {/* <Field name="protectorPhone" component={Input} placeholder="010-1234-5678" /> */}
                </div>
                <div>
                  <Field name="installDtm" component={installDtmComponent} />
                </div>
                <div>
                  <Field name="liveType" component={Input} placeholder="거주유형 입력" required />
                </div>
                {/* <div>
                  <Field name="sickType" component={Input} placeholder="보유지병 입력" />
                </div> */}
                <div className="checkBoxDiv">
                  <Field name="dangerYn" component={dangerYnComponent} />
                </div>
                <div className="checkBoxDiv">
                  <Field name="absenceYn" component={absenceYnComponent} />
                </div>
                <div className="checkBoxDiv">
                  <Field name="locationYn" component={locationYnComponent} />
                </div>
                <div className="checkBoxDiv">
                  <Field name="meainStatCode" component={installPlanComponent} />
                </div>
                <div className="noteFieldDiv">
                  <Field name="note" component={TextArea} autoSize={true} placeholder="특이사항 입력" />
                </div>
                {/* <div>
                  <Field name="lat" component={Input} type="number" placeholder="위도 입력" required />
                </div>
                <div>
                  <Field name="lng" component={Input} type="number" placeholder="경도 입력" required />
                </div> */}
                <div>
                  <label>
                    <Field name="streetAddress" component={addressInput} />
                  </label>
                  {/* <button 
                    style={{marginRight: "40px", border: "1px solid #ddd", fontSize: "14px", padding: "2px"}} 
                    onClick={handleClick}
                  >위경도 자동 입력
                  </button> */}
                </div>
                  <Field name="lat" component={latInput} type="number" placeholder="위도 입력" />
                  <Field name="lng" component={lngInput} type="number" placeholder="경도 입력" />
                {/* 
                <div>
                  <Field 
                    name='userPhone'
                    type='tel'
                    component={PhoneInput}
                    placeholder='010-1234-5678'
                    validator={phoneValidator}
                  />
                </div> */}
                <div className="elderInfoContBtn">
                  <Button onClick={closeEvt}>취소</Button>
                  {isNew ? (
                    <Button type="submit" disabled={!userId.check || !cid.check}>
                      저장
                    </Button>
                  ) : (
                    // <Button onClick={(e) => submit(e, dataItem, formRenderProps)} type="submit" disabled={(!formRenderProps.allowSubmit) || !cid.check} primary={true}>
                    <Button type="submit" disabled={!formRenderProps.allowSubmit || !cid.check}>
                      저장
                    </Button>
                  )}
                </div>
              </FormElement>
            )}
          />
        </div>
        <div>
        {elderInfo.addressInfo === true && (
          <ElderAddress
            conn={conn}
            elderInfo={elderInfo}
            setElderInfo={setElderInfo}
            setInfo={selectUnitAddress}
          />
        )}
        </div>
      </div>
    </Dialog>
  );
};
export default ElderInfo;
